import { z } from "zod/v4";

import { CustomEventDtoSchema } from "../../../dtos/analytics-events/custom-events";

export const UnarchiveCustomEventRequestBodySchema = z.object({
  customEventId: z.uuid(),
});

export type UnarchiveCustomEventRequestBodyType = z.infer<
  typeof UnarchiveCustomEventRequestBodySchema
>;

export const UnarchiveCustomEventResponseBodySchema = z.object({
  customEvent: CustomEventDtoSchema,
});

export type UnarchiveCustomEventResponseBodyType = z.infer<
  typeof UnarchiveCustomEventResponseBodySchema
>;
